module.exports = {
  merchantName: "Cuisine King",
  merchantDomain: "https://cuisinekingchinese.co.uk", // Need correct！ project will upload dist to targer domain file in Plesk.
  merchantMenuUrl: "/menu-cuisine-king", // target merchant's menu url in alleatapp.com
  // when you building files, fill this info, dont push these to github.
  pleskUsername: "root",
  pleskPs: "D03BQ3Hb",
};
